import { getRunwayTestData } from "./getRunwayTestData";
import { useEffect, useState } from "react";

const RunwayTestList = () => {
  const [items, setItems] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      const result = await getRunwayTestData();
      if (result.success) {
        setItems(result.data);
      } else {
        console.error("불러오기 실패:", result.error);
      }
    };

    fetchData();
  }, []);

  return (
    <div>
      <h2>Runway 테스트 리스트</h2>
      <ul>
        {items.map((item) => (
          <li key={item.id}>
            <strong>{item.name}</strong>: {item.title}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RunwayTestList;
